import { BreadcrumbItem } from "reactstrap";
import React from "react";
import cx from "classnames";

export type BreadcrumbCustomItemProps = {
  title: string | React.JSX.Element;
  isLastItem: boolean;
  withChevron: number;
  handleClick?: () => void;
};

export const BreadcrumbCustomItem = ({
  title,
  isLastItem,
  withChevron,
  handleClick,
}: BreadcrumbCustomItemProps) => (
  <BreadcrumbItem
    tag="button"
    onClick={handleClick}
    className="cursor-pointer text-gray-500 border-0 bg-transparent p-0"
  >
    {!!withChevron && <span className="mx-2">&gt;</span>}
    <span className={cx({ "text-blue-300": isLastItem })}>{title}</span>
    {withChevron === 0 && isLastItem && <span className="mx-2">&gt;</span>}
  </BreadcrumbItem>
);
